"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const react_circular_progressbar_1 = require("react-circular-progressbar");
require("react-circular-progressbar/dist/styles.css");
const colorDefinitions_1 = require("../../definitions/colorDefinitions");
const RoundProgressBar = (props) => {
    const { duration, backgroundColor, callBack, size, color, } = props;
    const values = [0, 20, 40, 60, 80, 100];
    const stepDuration = duration / (values.length - 1);
    let lastIntervalId;
    const getColor = () => {
        switch (color) {
            case 'green':
                return colorDefinitions_1.colorDefinitions.green80;
            case 'red':
                return colorDefinitions_1.colorDefinitions.pink80;
            case 'blue':
                return colorDefinitions_1.colorDefinitions.skyBlue60;
            case 'orange':
                return colorDefinitions_1.colorDefinitions.orange60;
            case 'yellow':
                return colorDefinitions_1.colorDefinitions.yellow60;
            default:
                return colorDefinitions_1.colorDefinitions.blue60;
        }
    };
    react_1.useEffect(() => {
        if (callBack !== undefined) {
            lastIntervalId = window.setTimeout(callBack, duration * 1000);
        }
        return () => {
            if (lastIntervalId != null) {
                clearTimeout(lastIntervalId);
            }
        };
    }, []);
    return (React.createElement("div", { style: { width: size, height: size } },
        React.createElement(ChangingProgressProvider, { values: values, intervalSeconds: stepDuration }, (percentage) => (React.createElement(react_circular_progressbar_1.CircularProgressbar, { value: percentage, strokeWidth: 50, key: 'percent', styles: react_circular_progressbar_1.buildStyles({
                pathColor: getColor(),
                pathTransition: 'linear',
                pathTransitionDuration: stepDuration,
                strokeLinecap: 'butt',
                trailColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'transparent',
            }) })))));
};
const ChangingProgressProvider = ({ intervalSeconds, values, children }) => {
    const [valuesIndex, setValuesIndex] = React.useState(0);
    let lastIntervalId;
    const increment = () => {
        if (valuesIndex <= values.length) {
            lastIntervalId = window.setTimeout(() => {
                setValuesIndex(((prevState) => prevState + 1));
                increment();
            }, intervalSeconds * 1000);
        }
    };
    react_1.useEffect(() => {
        if (!lastIntervalId) {
            lastIntervalId = window.setTimeout(() => {
                setValuesIndex(((prevState) => prevState + 1));
                increment();
            }, (1000));
        }
        return () => {
            clearTimeout(lastIntervalId);
        };
    }, []);
    return children(values[valuesIndex]);
};
exports.default = RoundProgressBar;
//# sourceMappingURL=RoundProgressBar.js.map